import { IconComponent } from '@repo/ui-icons';
import IconAi from '@repo/ui-icons/IconAi';
import IconBolt from '@repo/ui-icons/IconBolt';
import IconBook from '@repo/ui-icons/IconBook';
import IconCircleCheckBig from '@repo/ui-icons/IconCircleCheckBig';
import IconClose from '@repo/ui-icons/IconClose';
import IconGift from '@repo/ui-icons/IconGift';
import IconGlobe from '@repo/ui-icons/IconGlobe';
import IconLucideBell from '@repo/ui-icons/IconLucideBell';
import IconMarketing from '@repo/ui-icons/IconMarketing';
import IconMug from '@repo/ui-icons/IconMug';
import IconPencil from '@repo/ui-icons/IconPencil';
import IconPrintOrder from '@repo/ui-icons/IconPrintOrder';
import IconPublish from '@repo/ui-icons/IconPublish';
import IconScaleUp from '@repo/ui-icons/IconScaleUp';
import IconShadowStyle from '@repo/ui-icons/IconShadowStyle';
import IconStationery from '@repo/ui-icons/IconStationery';
import IconTextGen from '@repo/ui-icons/IconTextGen';
import IconTextures from '@repo/ui-icons/IconTextures';
import IconThumbUp from '@repo/ui-icons/IconThumbUp';
import IconTShirt from '@repo/ui-icons/IconTShirt';

export const iconMapping: Record<string, IconComponent> = {
  // image section icons
  BellIcon: IconLucideBell,
  CalendarIcon: IconTextGen, // no icon
  CloseIcon: IconClose,
  // category list icons
  'Shadow style': IconShadowStyle,
  'T-shirt': IconTShirt,
  'Thumb up': IconThumbUp,
  Marketing: IconMarketing,
  Mug: IconMug,
  Stationery: IconStationery,
  // Claims icons
  Eyelashes: IconPublish,
  Texture: IconTextures,
  Delivery: IconPrintOrder,
  BookIcon: IconBook,
  GlobeIcon: IconGlobe,
  GiftIcon: IconGift,
  CheckmarkCircleIcon: IconCircleCheckBig,
  // Tools library icons
  AI: IconAi,
  Pencil: IconPencil,
  'Scale Up': IconScaleUp,
  Bolt: IconBolt,
};

export const getSectionIcon = (
  name: string,
  defaultIcon?: IconComponent
): IconComponent | undefined => {
  return iconMapping[name] || defaultIcon;
};
